<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uUAMeQ/tc-custom/9780310873778.jpg?1728726022861" alt="This image is the cover for the book Showers in Season, Seasons Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Showers in Season, Seasons Series
      </h1>
      <p class="bookDescription body article font2">
        <p>On the quiet cul-de-sac of Cedar Circle, where neighbors are close friends, fierce winds of circumstance threaten to sweep one couple away. Their Down's Syndrome pregnancy is shattering news for Tory and Barry Sullivan, but the option Barry proposes is abhorrent to Tory. It will take a wisdom and strength greater than their own to carry them through. That, and the encouragement only a loving, close-knit community can provide. Over kitchen counters and across the miles, the women of Cedar Circle lend their support to Tory and to each other as all of them face their personal struggles, heartaches, and joys. Shining with bright faith and friendship that illuminates the stormiest night, Showers in Season explores the junction of life's realities, the cost of obedience, the power of relationships, and the promises of God.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beverly LaHaye, Terri Blackstock
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1559ec63